<template>
  <b-row>
    <b-col cols="12">
      <b-alert
        :show="dismissCountDownSuccess"
        dismissible
        variant="success"
        @dismissed="dismissCountDownSuccess = 0"
        @dismiss-count-down="countDownSuccessChanged"
        >{{ "Les informations PDF ont été enregistrées !" }}</b-alert
      >
      <b-alert
        :show="dismissCountDownError"
        dismissible
        variant="danger"
        @dismissed="dismissCountDownError = 0"
        @dismiss-count-down="countDownErrorChanged"
        >{{ "Il y a un problème lors de la mise à jour de la configuration pdf !" }}</b-alert
      >
    </b-col>
    <b-col v-if="!isLoading" cols="12" class="mb-5">
      <b-alert :show="charactersErrorPdfContactDetails != null" variant="danger">
        {{ charactersErrorPdfContactDetails }}
      </b-alert>
      <h3>Adresse de l'agence</h3>
      <tiptap
        v-model="pdfContactDetails"
        :placeholder="placeholderPdfContactDetails"
        :limited-rows="limitedRows"
        :limited-characters-per-row="limitedCharactersPerRow"
        @update="updateTextareaPdfContactDetails"
        @updateOnFocusOut="updatePdfContactDetails"
      />
    </b-col>
    <b-col v-if="!isLoading" cols="12" class="mb-5">
      <h3>Agence nom</h3>
      <b-input
        v-model="agencyName"
        type="text"
        maxlength="30"
        :placeholder="placeholderAgencyName"
        @input="updateAgencyName"
      />
    </b-col>
    <b-col v-if="!isLoading" cols="12">
      <h3>Agence e-mail</h3>
      <b-input
        v-model="agencyEmail"
        :placeholder="placeholderAgencyEmail"
        type="email"
        maxlength="40"
        @input="updateAgencyEmail"
      />
      <b-button
        v-if="!isNew"
        :disabled="isDisabled"
        class="button btn-blue my-4 fw-600"
        @click="updateAgencyConfigs()"
      >
        Enregistrer
      </b-button>
      <b-button
        v-else
        :disabled="isDisabled"
        class="button btn-blue my-4 fw-600"
        @click="createAgencyConfigs()"
      >
        Enregistrer
      </b-button>
    </b-col>
    <appLoader v-if="isLoading" />
  </b-row>
</template>

<script>
import ConfigurationMW from "@/middlewares/Configuration";
import ConfigurationORM from "@/store/orm-axios/models/Configuration";
import Tiptap from "@/components/snippets/Tiptap.vue";

export default {
  components: {
    Tiptap,
  },
  data() {
    return {
      agencyName: "",
      agencyEmail: "",
      pdfContactDetails: "",
      configuration: null,
      hasAgencyName: false,
      hasAgencyEmail: false,
      hasPdfContactDetails: false,
      isLoading: true,
      isDisabled: false,
      dismissCountDownSuccess: 0,
      dismissCountDownError: 0,
      isNew: false,
      placeholderAgencyName: "Entrez le nom de l'agence",
      placeholderAgencyEmail: "Entrez l'adresse e-mail de l'agence",
      placeholderPdfContactDetails: "Entrez les coordonnées de l'organisateur",
      limitedCharactersPerRow: 80,
      limitedRows: 4,
      charactersErrorPdfContactDetails: null,
    };
  },
  computed: {
    agencyId() {
      return Number(localStorage.getItem("agencyId"));
    },
    configurationComputed() {
      // There will be only one configuration for each agency id
      return ConfigurationORM.query().where("agency_id", this.agencyId).first();
    },
  },
  watch: {
    configurationComputed(newValue) {
      this.configuration = newValue;
      this.getAgencyConfigs();
    },
  },
  created() {
    ConfigurationMW.FETCH(this.agencyId)
      .then(() => {
        this.isLoading = false;
        this.configuration = this.configurationComputed;
        this.getAgencyConfigs();
        if (!this.configuration) {
          this.isNew = true;
        }
      })
      .catch(err => {
        this.isLoading = false;
      });
  },
  methods: {
    getAgencyConfigs() {
      // Get current agency values
      if (
        this.configuration &&
        this.configuration.settings &&
        this.configuration.settings.length > 0
      ) {
        this.configuration.settings.forEach(element => {
          if (element.agency_name || element.agency_name == "") {
            this.agencyName = element.agency_name;
            this.hasAgencyName = true;
          }
          if (element.agency_email || element.agency_email == "") {
            this.agencyEmail = element.agency_email;
            this.hasAgencyEmail = true;
          }
          if (element.pdf_contact_details) {
            this.pdfContactDetails = element.pdf_contact_details;
            this.hasPdfContactDetails = true;
          }
        });
      }
    },
    setAgencyName() {
      // If agency_name exists in json, just update it
      if (this.hasAgencyName) {
        this.configuration.settings.forEach(element => {
          if (element.agency_name || element.agency_name == "") {
            element.agency_name = this.agencyName;
          }
        });
      } else {
        // If json exists and agency_name is missing, add it to json
        if (
          this.configuration &&
          this.configuration.settings &&
          this.configuration.settings.length > 0
        ) {
          this.configuration.settings.push({
            agency_name: this.agencyName,
          });
        } else if (this.configuration) {
          // If json is empty, add the agency_name object in an array
          this.configuration.settings = [
            {
              agency_name: this.agencyName,
            },
          ];
        } else {
          // If json is null, add the agency_name object in an array
          this.configuration = [];
          this.configuration.settings = [
            {
              agency_name: this.agencyName,
            },
          ];
        }
      }
    },
    setAgencyEmail() {
      // If agency_email exists in json, just update it
      if (this.hasAgencyEmail) {
        this.configuration.settings.forEach(element => {
          if (element.agency_email || element.agency_email == "") {
            element.agency_email = this.agencyEmail;
          }
        });
      } else {
        // If json exists and agency_email is missing, add it to json
        if (
          this.configuration &&
          this.configuration.settings &&
          this.configuration.settings.length > 0
        ) {
          this.configuration.settings.push({
            agency_email: this.agencyEmail,
          });
        } else if (this.configuration) {
          // If json is empty, add the agency_email object in an array
          this.configuration.settings = [
            {
              agency_email: this.agencyEmail,
            },
          ];
        } else {
          // If json is empty, add the agency_email object in an array
          this.configuration = [];
          this.configuration.settings = [
            {
              agency_email: this.agencyEmail,
            },
          ];
        }
      }
    },
    setPdfContactDetails() {
      // If pdf_contact_details exists in json, just update it
      if (this.hasPdfContactDetails) {
        this.configuration.settings.forEach(element => {
          if (element.pdf_contact_details) {
            element.pdf_contact_details = this.pdfContactDetails;
          }
        });
      } else {
        // If json exists and pdf_contact_details is missing, add it to json
        if (
          this.configuration &&
          this.configuration.settings &&
          this.configuration.settings.length > 0
        ) {
          this.configuration.settings.push({
            pdf_contact_details: this.pdfContactDetails,
          });
        } else if (this.configuration) {
          // If json is empty, add the pdf_contact_details object in an array
          this.configuration.settings = [
            {
              pdf_contact_details: this.pdfContactDetails,
            },
          ];
        } else {
          // If json is empty, add the pdf_contact_details object in an array
          this.configuration = [];
          this.configuration.settings = [
            {
              pdf_contact_details: this.pdfContactDetails,
            },
          ];
        }
      }
    },
    countDownSuccessChanged(dismissCountDown) {
      this.dismissCountDownSuccess = dismissCountDown;
    },
    countDownErrorChanged(dismissCountDown) {
      this.dismissCountDownError = dismissCountDown;
    },
    updateAgencyConfigs() {
      if (this.charactersErrorPdfContactDetails) {
        return;
      }
      this.isDisabled = true;
      this.setAgencyName();
      this.setAgencyEmail();
      this.setPdfContactDetails();
      ConfigurationMW.PUT(this.configuration)
        .then(() => {
          this.isDisabled = false;
          this.dismissCountDownSuccess = 5;
        })
        .catch(err => {
          this.isDisabled = false;
          this.dismissCountDownError = 5;
          console.log("err: ", err);
        });
    },
    createAgencyConfigs() {
      if (this.charactersErrorPdfContactDetails) {
        return;
      }
      this.isDisabled = true;
      this.setAgencyName();
      this.setAgencyEmail();
      this.setPdfContactDetails();
      let configurationObj = {
        agencyId: this.agencyId,
        settings: this.configuration.settings,
      };
      ConfigurationMW.POST(configurationObj)
        .then(() => {
          this.isDisabled = false;
          this.dismissCountDownSuccess = 5;
        })
        .catch(err => {
          this.isDisabled = false;
          this.dismissCountDownError = 5;
          console.log("err: ", err);
        });
    },
    updateAgencyEmail(agencyEmail) {
      this.agencyEmail = agencyEmail;
    },
    updateAgencyName(agencyName) {
      this.agencyName = agencyName;
    },
    updateTextareaPdfContactDetails(event) {
      let message = "";
      if (event.rowLengthExceded) {
        message = `La longueur de ligne est limitée à ${this.limitedRows}.`;
      }
      if (event.rowCharactersLengthExceded) {
        message += ` La longueur des caractères de la ligne est limitée à ${this.limitedCharactersPerRow}.`;
      }
      if (message.length > 1) {
        this.charactersErrorPdfContactDetails = message;
      } else {
        this.charactersErrorPdfContactDetails = null;
      }
    },
    updatePdfContactDetails(pdfContactDetails) {
      this.pdfContactDetails = pdfContactDetails;
    },
  },
};
</script>
